/**
 * FragmentModeToggle Component
 *
 * Toggle para o modo de descoberta de Fragments.
 * Quando ativado, mostra marcadores visuais nos FragmentGate.
 *
 * @since 2026-01-09
 * @updated 2026-03-11 - Simplificado para label + ícone de olho
 */

import React from 'react';
import { useFragmentMode } from '@/contexts/FragmentModeContext';

export function FragmentModeToggle() {
  const { isFragmentModeEnabled, toggleFragmentMode } = useFragmentMode();

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={toggleFragmentMode}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') toggleFragmentMode(); }}
      className="flex items-center justify-between gap-3 w-full cursor-pointer"
      title={isFragmentModeEnabled ? 'Desativar Fragmentos' : 'Ativar Fragmentos'}
    >
      <span className="text-sm text-foreground">
        Fragmentos
      </span>
      <i
        className={`bi ${isFragmentModeEnabled ? 'bi-eye-fill' : 'bi-eye-slash'} text-base transition-colors ${
          isFragmentModeEnabled
            ? 'text-purple-600 dark:text-purple-400'
            : 'text-muted-foreground'
        }`}
      />
    </div>
  );
}
